import React from 'react';
import ModalWrapper from '../ModalWrapper';

import ModalContactMeBody from './ModalContactMe';


const ModalContact = ({isOpen, onCloseModal}) => (
    <ModalWrapper isOpen={isOpen} cssClass="modal-contact-me">
        <ModalContactMeBody onCloseModal={onCloseModal} />
    </ModalWrapper>
);

export default ModalContact;